import { render, staticRenderFns } from "./MyAccountMenu.vue?vue&type=template&id=749aea30&scoped=true&"
import script from "./MyAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./MyAccountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountMenu.vue?vue&type=style&index=0&id=749aea30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749aea30",
  null
  
)

export default component.exports